import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import { useTasteProfile } from '@/hooks/useTasteProfile';
import WineStyleBar from '@/components/ui/WineStyleBar';
import Button from '@/components/ui/Button';
import PageHeader from '@/components/layout/PageHeader';

export default function Profile() {
  const { user, isAdmin, signOut } = useAuth();
  const navigate = useNavigate();
  const { snapshot, loading } = useTasteProfile();

  const email = user?.signInDetails?.loginId ?? '';
  const firstName = email.split('@')[0];

  return (
    <div className="page page-profile">
      <PageHeader title="Me" />

      <div className="profile-user">
        <div className="profile-avatar">{firstName.charAt(0).toUpperCase()}</div>
        <div>
          <p className="profile-name">{firstName}</p>
          <p className="profile-email">{email}</p>
          {isAdmin && <span className="profile-admin-badge">Admin</span>}
        </div>
      </div>

      {!loading && snapshot && (
        <section className="profile-section">
          <h2 className="section-title">Your taste profile</h2>
          <p className="profile-stat">{snapshot.totalTasted} wines tasted</p>

          <div className="profile-taste-bars">
            <WineStyleBar label="Body" value={snapshot.tasteProfile.body} lowLabel="Light" highLabel="Full" />
            <WineStyleBar label="Tannin" value={snapshot.tasteProfile.tannin} lowLabel="Soft" highLabel="Grippy" />
            <WineStyleBar label="Acidity" value={snapshot.tasteProfile.acidity} lowLabel="Low" highLabel="Crisp" />
            <WineStyleBar label="Oak" value={snapshot.tasteProfile.oak} lowLabel="Unoaked" highLabel="Oaked" />
            <WineStyleBar label="Sweetness" value={snapshot.tasteProfile.sweetness} lowLabel="Dry" highLabel="Sweet" />
          </div>

          {snapshot.topGrapes.length > 0 && (
            <div className="profile-top-list">
              <h3>Favourite grapes</h3>
              <p>{snapshot.topGrapes.join(', ')}</p>
            </div>
          )}

          {snapshot.topRegions.length > 0 && (
            <div className="profile-top-list">
              <h3>Favourite regions</h3>
              <p>{snapshot.topRegions.join(', ')}</p>
            </div>
          )}
        </section>
      )}

      {!loading && !snapshot && (
        <section className="profile-section profile-empty">
          <p>Rate a few wines to build your taste profile.</p>
        </section>
      )}

      <section className="profile-section">
        <h2 className="section-title">Actions</h2>
        <Button variant="secondary" fullWidth onClick={() => navigate('/lists')}>
          Shared lists
        </Button>
        {isAdmin && (
          <Button variant="secondary" fullWidth onClick={() => navigate('/admin')}>
            Admin panel
          </Button>
        )}
        <Button variant="ghost" fullWidth onClick={signOut}>
          Sign out
        </Button>
      </section>
    </div>
  );
}
